import { useEffect, useRef } from "react";
import { migrateProfile } from "../services/session";
import { useProfile } from "@/hooks/firestore/user/useProfile";

const CURRENT_MIGRATION_VERSION = 29;

export const useProfileMigration = () => {
  const { profile } = useProfile();
  const hasMigrated = useRef(false);

  const migrationVersion = profile?.migration;
  const needsMigration =
    migrationVersion === undefined ||
    migrationVersion < CURRENT_MIGRATION_VERSION;

  useEffect(() => {
    if (!profile || hasMigrated.current || !needsMigration) return;

    hasMigrated.current = true;
    migrateProfile();
  }, [profile, needsMigration]);
};
